/**
 * Portfolios → Trades (TRADE-LIST, Pedro 2026-10-25): every trade of every portfolio. TRADE-FLOW
 * (0122): a row opens the trade's side panel, whose steps commit at once through their own
 * confirm (§3g Pattern B), so this tab has no Edit / Save of its own.
 */
import { Group, Stack, Text } from '@mantine/core';

import type { TradeDraft, TradeRun } from '../api/trades';
import { AdminOverrideSwitch, useAdminOverride } from '../hooks/useAdminOverride';
import { usePermissions } from '../hooks/usePermissions';
import { TradesList } from './TradesList';

export function PortfolioTradesTab({ onOpen, onOpenRun }: { onOpen: (t: TradeDraft) => void; onOpenRun: (r: TradeRun) => void }) {
  const { can } = usePermissions();
  const override = useAdminOverride();   // N5: the Admin override (Beta)
  return (
    <Stack gap="xs">
      <Group gap="xs">
        <AdminOverrideSwitch />
        <Text size="xs" c="dimmed" ml="auto">Click a trade to see its history, documents and emails, and to take its next step.</Text>
      </Group>
      <TradesList showAgreement canAct={can('trades.draft')} override={override} onOpen={onOpen} onOpenRun={onOpenRun} />
    </Stack>
  );
}
